// Import from NPM
// -------------------------------------
import React, { useState } from "react";
import { Icon, Divider } from "semantic-ui-react";

// Import from Config
// -------------------------------------
import "@styles/layouts.scss";
import { Div } from "@components/Generics.react";
import { darkStyle } from "@utilities/helpers";
import { settings } from "@config/settings/app.settings";

import LeftMenu from "@components/LeftMenu.react";
import BottomMenu from "@components/BottomMenu.react";

export default function CommonPanel(props) {
    const {
        mainPanel,
        rightPanel,
        rightPanelName,
        fullScreen,
        hidePanelToggle,
    } = props;
    const [showRightMenu, setShowRightMenu] = useState(false);
    const isPortrait = window.innerHeight > window.innerWidth;

    return isPortrait ? (
        <Div
            className="player-view"
            layer={-1}
            fluid
            basepad={showRightMenu}
            rounded
        >
            {showRightMenu && (
                <Icon
                    name="close"
                    circular
                    inverted
                    className="right-panel-close"
                    onClick={() => setShowRightMenu(false)}
                />
            )}
            <Div
                className={`${showRightMenu ? "right" : "main"}-panel`}
                relative
                fitted
                vapor={!showRightMenu}
                ash={showRightMenu}
                fullht
                fluid
                trench
                autoOverflowY={!showRightMenu}
                noOverflow={showRightMenu}
            >
                {showRightMenu ? rightPanel : mainPanel}
                <Divider />
                {isPortrait && <Div ht="80px" />}
            </Div>
            <Div className="bottom-menu">
                {!showRightMenu && !hidePanelToggle && (
                    <Div
                        className="bottom-panel-opener"
                        style={darkStyle(settings.colors.main)}
                        onClick={() => setShowRightMenu(true)}
                    >
                        {rightPanelName} <Icon name="chevron up" />
                    </Div>
                )}
                <BottomMenu />
            </Div>
        </Div>
    ) : (
        <Div className="player-view" layer={-1} fluid fullht>
            <Div className="left-panel" relative float-left fullht>
                <LeftMenu />
            </Div>
            <Div
                fullht
                float-left
                className={`main-panel-viewport ${fullScreen && "fullscreen"}`}
            >
                <Div
                    className="main-panel"
                    relative
                    rounded
                    padded
                    spaced
                    fullht
                    big
                    autoOverflowY
                >
                    {mainPanel}
                </Div>
            </Div>
            {!fullScreen && (
                <Div
                    className="right-panel"
                    relative
                    float-left
                    topRounded
                    padded
                    fullht
                    ash
                >
                    {rightPanel}
                </Div>
            )}
        </Div>
    );
}
